import React from "react";
import { useTranslation } from "react-i18next";

import { FilterMenu } from "@common/filterMenu";
import { Sort } from "./sort";
import { Props } from "./types";
import styles from "./styles.scss";

function Toolbar(props: Props) {
  const { t } = useTranslation();
  const { resources, roles, organizationalUnits } = props.filter;

  return (
    <div className={styles.toolbar}>
      <div className={styles.section}>
        <p className={styles.title}>{t("zonesPage.projects.sorter.title")}</p>
        <div className={styles.sort}>
          <Sort {...props} />
        </div>
      </div>
      <div className={styles.section}>
        <p className={styles.title}>{t("zonesPage.projects.filters.title")}</p>
        <div className={styles.filter}>
          <FilterMenu
            filter={props.filter}
            placeholder={t("zonesPage.projects.filters.placeholderZone")}
            setFilter={(nextFilter) =>
              props.setFilter({
                ...nextFilter,
                resources,
                roles,
                organizationalUnits,
              })
            }
            views={[
              "zones",
              "projects",
              "projectPortfolios",
              "projectStatuses",
              "projectsTags",
              "projectStatuses",
            ]}
            openedViews={["zones"]}
          />
        </div>
      </div>
      <div className={styles.section}>
        <p className={styles.title}>
          {t("zonesPage.projects.filters.showProjectsOf")} :
        </p>
        <div className={styles.filter}>
          <FilterMenu
            filter={props.filter}
            placeholder={t("zonesPage.projects.filters.placeholderResource")}
            setFilter={(nextFilter) =>
              props.setFilter({
                ...props.filter,
                resources: nextFilter.resources,
                roles: nextFilter.roles,
                organizationalUnits: nextFilter.organizationalUnits,
              })
            }
            views={["resources", "roles", "organizationalUnits"]}
            openedViews={["resources"]}
            roleScope="project"
          />
        </div>
      </div>
    </div>
  );
}

export { Toolbar };
